<template>
  <div class="row ribon">
    <div class="block">
      <h1>
        <a href="#">
          <v-icon color="black" small class="mr-2 ml-2">{{icon}}</v-icon>
          {{mainText}}
          <div v-if="cnpjCpf" class="snd_line">
            <small>{{adptaTextCpfCnpj}}: {{maskCnpj}}</small>
          </div>
        </a>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ["mainText", "icon", "cnpjCpf"],
  data: () => ({}),
  mounted: function() {
    this.$nextTick(function() {});
  },
  computed: {
    maskCnpj: function() {
      return this.cnpjCpf
        ? this.cnpjCpf.length > 11
          ? this.cnpjCpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
          : this.cnpjCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")
        : "";
    },
    adptaTextCpfCnpj: function(){
        return this.cnpjCpf.length > 11 ? 'CNPJ' : 'CPF'
    }
  },
  watch: {},
  methods: {}
};
</script>
<style scoped>
.row {
  display: table;
  height: 100%;
  margin: auto;
}

.block {
  display: table-cell;
  width: 100%;
  vertical-align: middle;
  position: relative;
}

h1 {
  position: relative;
  display: inline-block;
  font-family: "Times New Roman", times, serif;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
  text-align: center;
  font-size: 1em;
  text-transform: uppercase;
}
h1:after,
h1:before {
  content: " ";
  display: block;
  position: absolute;
  bottom: -0.5em;
  width: 1em;
  height: 100%;
  background-color: #69c48d;
  pointer-events: none;
}
h1:after {
  right: -0.57em;
  z-index: -1;
}
h1:before {
  bottom: auto;
  top: -0.5em;
  left: -0.57em;
  z-index: -1;
}
h1 a {
  display: inline-block;
  position: relative;
  padding: 0.15em 0.75em;
  text-decoration: none;
  color: #192238;
  background-color: #ffffff;
  border: thin solid #b2b2b2;
}
h1 a:after,
h1 a:before {
  content: " ";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  bottom: -0.5em;
  left: -0.05em;
  pointer-events: none;
  -webkit-mask: none;
}
h1 a:before {
  bottom: auto;
  top: -0.5em;
  border-bottom: 0.5em solid #398e5b;
  border-left: 1.5em solid transparent;
}
h1 a:after {
  left: auto;
  right: -0.05em;
  border-top: 0.5em solid #398e5b;
  border-right: 1.5em solid transparent;
}
.snd_line {
  color: #696b6d;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ribbon/Ribbon.vue